export const LoadingPlaces = () => {
  return (
    <div className="alert alert-primary mt-2 text-center">
      <h6>Searching...</h6>
      <p>We're finding your places</p>
    </div>
  );
};
